export function isPermite(cod: string) {
    const storLogin = sessionStorage.getItem('infoLogin');
    if(storLogin){
        const infoLogin = JSON.parse(storLogin);
        const permissoes = String(infoLogin.permissoes_usuario).split(',');
        const is = permissoes.filter((p:string) => p === cod);
        if(is.length === 1) return true;
    }
    return false;
}